module.exports = __webpack_public_path__ + "static/amarok-a5c6d0d1656070a2b33919a6fd2290eb.png";